import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ensureEstatesQueryData } from '@/features/estates/api/estates';
import { SORT_BY_DIRECTION, SORT_BY_VALUES } from '@/utils/sortTypes';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/estates/me')({
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['grid', 'list', 'map']), 'list'),
      search: fallback(z.string().optional(), ''),
      enableFilters: fallback(z.boolean(), false),
      filterOwn: fallback(z.boolean(), true),
      sort: fallback(
        z
          .object({
            by: z.enum(SORT_BY_VALUES),
            order: z.enum(SORT_BY_DIRECTION),
          })
          .optional(),
        undefined
      ),
      filters: z.record(z.unknown()).optional(),
    })
  ),
  loader: ensureEstatesQueryData,
});
